import { t } from "@/i18n-js/instance";

export const calculateProgress = (max: number, used: number): number => {
  if (max === 0) return 0;
  return Math.round((used / max) * 100);
};

export const getUsageDetailsDescription = (
  currentUsage: number,
  totalUsage: number,
) =>
  t("settings.billing.manage_billing.usage_details.resource_of", {
    current_usage: currentUsage,
    total_usage: totalUsage,
  });
